<div class="generalPage" aria-label="help glossaries" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont" role="heading">{{glossaries_header}}</h1>
    <p class="answer font-16 content-blue width-100" [innerHTML]="glossaries_desc"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{glossaries_para1heading}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="glossaries_para1body"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{glossaries_para2heading}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="glossaries_para2body"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{glossaries_para3heading}}</p>
    <p class="answer font-16 content-blue width-100" (click)="openlink($event)" [innerHTML]="glossaries_para3body"></p>
  </div>
</div>

